function checkForZeros(object) {
    let errors = {};
  
    return errors
  }
  
  function checkForOverflow(object) {
    let errors = {};
  
    return errors
  }

export default function validate(data, templates = []) {
    let errors = {};

    if (!data.template_name) {
        errors.template_name = 'template_name_error';
    } else {
        // Check for duplicate template names
        const isDuplicate = templates.find((template) => template.template_name === data.template_name);
        if (isDuplicate) {
            errors.template_name = 'Шаблон с таким названием уже существует';
        }
    }

    if (!data.contract_number) {
        errors.contract_number = 'contract_number_error';
    }

    return errors
}